import { render, staticRenderFns } from "./area-report.component.vue?vue&type=template&id=9cd9f8f6&scoped=true"
import script from "./area-report.component.ts?vue&type=script&lang=ts&external"
export * from "./area-report.component.ts?vue&type=script&lang=ts&external"
import style0 from "./area-report.component.vue?vue&type=style&index=0&id=9cd9f8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd9f8f6",
  null
  
)

export default component.exports